import { render, staticRenderFns } from "./ConsultationStartScreen.vue?vue&type=template&id=02a56fc4&scoped=true"
import script from "./ConsultationStartScreen.vue?vue&type=script&lang=ts"
export * from "./ConsultationStartScreen.vue?vue&type=script&lang=ts"
import style0 from "./ConsultationStartScreen.vue?vue&type=style&index=0&id=02a56fc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.2.47_babel-core@7.0.0-bridge.0_@babel+core@7.20.12__cs_dsp4ve4m4u4ggk2pimednah2wa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a56fc4",
  null
  
)

export default component.exports